<template>
  <DpplChip
    chip-color="grey400"
    :chip-height="20"
    reduce-font-size
    class="ml-4"
    :is-active="isSelected"
    data-png-ignore
    @click="$emit('set-candidate-stage', stage)"
  >
    <template #label>
      See {{ value }} Applicant{{ value !== 1 ? 's' : '' }}
    </template>
    <ArrowDown
      :style="{
        transition: 'transform .2s',
        transform: isSelected ? 'rotate(180deg)' : '',
      }"
      class="ml-1"
    />
  </DpplChip>
</template>

<script setup>
import DpplChip from '@/components/datapeople/DpplChip.vue';
import ArrowDown from '@/assets/arrow_down.svg?component';

defineProps({
  stage: { type: String, required: true },
  value: { type: Number, required: true },
  isSelected: { type: Boolean, default: false },
});

defineEmits(['set-candidate-stage']);
</script>

<style scoped lang="less">
.v-chip {
  padding: 4px 8px !important;

  &.is-active :deep(path) {
    stroke: @white;
  }
}

:deep(.v-chip__content) {
  font-size: 10px;
}
</style>
